import __request__ from "routing/request";
export function adapters(sort = "title", page = 1, per_page = 50, order = "desc", query, requestOptions) {
  return __request__("GET", "/system/lookup/adapters", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createAdapter(JSONbody, requestOptions) {
  return __request__("POST", "/system/lookup/adapters", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateAdapter(JSONbody, requestOptions) {
  return __request__("POST", "/system/lookup/adapters/validate", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteAdapter(idOrName, requestOptions) {
  return __request__("DELETE", `/system/lookup/adapters/${idOrName}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateAdapter(JSONbody, idOrName, requestOptions) {
  return __request__("PUT", `/system/lookup/adapters/${idOrName}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAdapter(idOrName, requestOptions) {
  return __request__("GET", `/system/lookup/adapters/${idOrName}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function performAdapterLookup(name, key, requestOptions) {
  return __request__("GET", `/system/lookup/adapters/${name}/query`, null, { "key": key }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function caches(sort = "title", page = 1, per_page = 50, order = "desc", query, requestOptions) {
  return __request__("GET", "/system/lookup/caches", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createCache(JSONbody, requestOptions) {
  return __request__("POST", "/system/lookup/caches", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateCache(JSONbody, requestOptions) {
  return __request__("POST", "/system/lookup/caches/validate", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteCache(idOrName, requestOptions) {
  return __request__("DELETE", `/system/lookup/caches/${idOrName}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateCache(JSONbody, idOrName, requestOptions) {
  return __request__("PUT", `/system/lookup/caches/${idOrName}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getCache(idOrName, requestOptions) {
  return __request__("GET", `/system/lookup/caches/${idOrName}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function errorStates(request, requestOptions) {
  return __request__("POST", "/system/lookup/errorstates", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function tables(sort = "title", page = 1, per_page = 50, order = "desc", query, resolve = false, requestOptions) {
  return __request__("GET", "/system/lookup/tables", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query, "resolve": resolve }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createTable(JSONbody, requestOptions) {
  return __request__("POST", "/system/lookup/tables", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPreview(idOrName, size = 5, requestOptions) {
  return __request__("GET", `/system/lookup/tables/preview/${idOrName}`, null, { "size": size }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateTable(JSONbody, requestOptions) {
  return __request__("POST", "/system/lookup/tables/validate", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateTable(JSONbody, idOrName, requestOptions) {
  return __request__("PUT", `/system/lookup/tables/${idOrName}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeTable(idOrName, requestOptions) {
  return __request__("DELETE", `/system/lookup/tables/${idOrName}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(idOrName, resolve = false, requestOptions) {
  return __request__("GET", `/system/lookup/tables/${idOrName}`, null, { "resolve": resolve }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function performPurge(idOrName, key, requestOptions) {
  return __request__("POST", `/system/lookup/tables/${idOrName}/purge`, null, { "key": key }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function performLookup(name, key, requestOptions) {
  return __request__("GET", `/system/lookup/tables/${name}/query`, null, { "key": key }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function availableAdapterTypes(requestOptions) {
  return __request__("GET", "/system/lookup/types/adapters", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function availableCacheTypes(requestOptions) {
  return __request__("GET", "/system/lookup/types/caches", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
